<i18n
  src="@/locales/views/organization/process/packing/show_harvested_batch.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>

<template>
  <go-back-link :text="$t('labels.go_back_link')" :name="routeName('show_process')" :params="{
    organization_id: organization_id,
    harvest_process_id: harvest_process_id
  }" />
  <bread-crumbs :labels="[module_name, harvest_process.name]" />
  <template v-if="load_data_general">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.week") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.week }}
                </dd>
              </div>

              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.batch_code") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.batch_code }}
                </dd>
              </div>

              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.registered_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(harvested_batch.registered_at) }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.producer") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.producer.producer_code }}
                  {{ harvested_batch.producer.fullname }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.crop_field") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.crop_field?.name }}
                </dd>
              </div>
              <!-- <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.total_weight") }}
                </dt>
                <dd class="content-data">
                  {{ numberWithPrecision(harvested_batch.total_weight) }}
                </dd>
              </div> -->
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_package.crop_har_package") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_packages }}
                </dd>
              </div>
              <!-- <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.crop_type") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.crop_type.name }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.crop_variety") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.crop_variety.name }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.agro_exporter_process") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.agro_exporter_process?.name }} -
                  {{ harvested_batch.agro_exporter?.name }}
                </dd>
              </div> -->
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.harvest_team") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.harvest_team?.harvest_team_code }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.process_line") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.process_line?.name }}
                </dd>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions space-y-3 my-3 md:space-y-0 md:my-0">
            <destroy-button v-if="!proc_button_destroy" :disabled_button="proc_button_destroy"
              @destroyEvent="destroyHarvestedBatch()" :label="$t('labels.destroy_button_label')" :title="$t('labels.destroy_button_title', {
                batch_code: harvested_batch.batch_code
              })
                " :message="$t('labels.destroy_button_message')"
              :label_confirm="$t('labels.destroy_button_label_confirm')" />
            <destroy-button-processing v-else :label="$t('labels.destroy_button_label')" />
            <span class="space-actions"></span>
            <edit-button @click.prevent="goToEditHarvestedBatch()" :label="$t('labels.edit_button')" />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 flex flex-row">
      <h1 class="page-title">
        <i class="fa-solid fa-box"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_packages") }}
      </h1>
    </div>
    <div class="mt-4 flex flex-row justify-between">
      <div class="panel-plain-label space-x-0 md:space-x-4 space-y-1 md:space-y-0">
        <badge-default v-for="(value, key, index) in quantity_by_crop_exp_packages" :key="index"
          :label="`${value} ${key} Kg`" />
      </div>
      <new-button @click.prevent="goToNewPackage()" :label="$t('labels.new_button')" />
    </div>
    <div class="mt-6 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.producer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exported_batch.crop_field") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_brand") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.process_line") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.quantity") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr class="table-row" v-for="pkg in packages" :key="pkg.id">
                  <td class="table-cell">
                    {{ pkg.producer.fullname }}
                  </td>
                  <td class="table-cell">
                    {{ pkg.exported_batch?.crop_field?.name }}
                  </td>
                  <td class="table-cell">
                    {{ pkg.exporter_process_brand.agro_exporter_brand.name }}
                  </td>
                  <td class="table-cell">
                    {{ pkg.process_line?.name }}
                  </td>
                  <td class="table-cell">
                    {{ pkg.quantity }}
                    {{
                      $t("model.package.exporter_process_crop_package_value", {
                        name: pkg.exporter_process_crop_package.name,
                        weight: pkg.exporter_process_crop_package.net_weight
                      })
                    }}
                  </td>
                  <td class="table-cell-action">
                    <destroy-button v-if="!pkg.proc_button_destroy" @destroyEvent="destroyPackage(pkg)"
                      :label="$t('labels.destroy_button_label')" :title="$t('labels.destroy_pkg_button_title')"
                      :message="$t('labels.destroy_pkg_button_message')"
                      :label_confirm="$t('labels.destroy_button_label_confirm')" />
                    <destroy-button-processing v-else :label="$t('labels.destroy_button_label')" />
                    <span class="space-actions"></span>
                    <edit-button :label="$t('labels.edit_button')" @click="goToEditPackage(pkg)">
                    </edit-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/process/packing/show_harvested_batch.js";
import ManageRequester from "@/views/organization/requesters/process/packing/manage_harvested_batch.js";
import ManagePackageRequester from "@/views/organization/requesters/process/packing/manage_package.js";

export default {
  name: "OrgProcessPackingShowHarvestedBatch",
  data() {
    return {
      load_data_general: false,
      proc_button_destroy: false,
      harvest_process: {},
      harvested_batch: {},
      packages: [],
      harvest_process_id: null
    };
  },
  props: {
    organization_id: { required: true },
    harvested_batch_id: { required: true }
  },
  computed: {
    harvested_packages: function () {
      let h_packages = this.harvested_batch.harvested_packages;
      return h_packages.map(harvested_package => {
        let label = `${harvested_package.number} ${harvested_package.crop_har_package.name}`
        if (harvested_package.ratio_boxes_by_harvested) label = this.addRatioBoxesByHarvested(harvested_package, label);
        if (harvested_package.discarded_number) label = `${label} (${this.$t('model.harvested_package.discarded_number')}: ${harvested_package.discarded_number})`;
        return label
      }).join(", ");
    },
    quantity_by_crop_exp_packages: function () {
      return this.packages.reduce((p, pkg) => {
        let name = `${pkg.exporter_process_crop_package.name} de ${pkg.exporter_process_crop_package.net_weight}`;
        if (!Object.hasOwn(p, name)) p[name] = 0;
        p[name] += pkg.quantity;
        return p;
      }, {});
    }
  },
  methods: {
    addRatioBoxesByHarvested: function (harvested_package, label) {
      let ratio = harvested_package.ratio_boxes_by_harvested;
      if (!ratio) return;

      ratio = this.numberWithPrecision(ratio);
      label = `${label} (${ratio} ${this.$t("model.harvested_batch.num_packages")} x ${harvested_package.crop_har_package.name})`
      return label
    },
    loadData: async function () {
      await this.fetchHarvestedBatch();
      await this.fetchHarvestProcess();
      await this.fetchPackages();
      this.load_data_general = true;
    },
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_process = response.data;
    },
    fetchHarvestedBatch: async function () {
      let response = await Requester.fetchHarvestedBatch(
        this.organization_id,
        this.harvested_batch_id
      );
      this.harvested_batch = response.data;
      this.harvest_process_id = this.harvested_batch.harvest_process_id;
    },
    fetchPackages: async function () {
      let response = await Requester.fetchPackages(
        this.organization_id,
        this.harvested_batch_id
      );
      this.packages = response.data;
      this.packages.forEach(pkg => (pkg["proc_button_destroy"] = false));
    },
    goToEditHarvestedBatch: function () {
      this.$router.push({
        name: this.routeName("edit_harvested_batch"),
        params: {
          organization_id: this.organization_id,
          harvested_batch_id: this.harvested_batch_id
        }
      });
    },
    destroyHarvestedBatch: async function () {
      this.proc_button_destroy = true;
      try {
        let response = await ManageRequester.destroy(
          this.organization_id,
          this.harvested_batch_id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_button_destroy = false;
    },
    goToNewPackage: function () {
      this.$router.push({
        name: this.routeName("new_package"),
        params: {
          organization_id: this.organization_id,
          harvested_batch_id: this.harvested_batch_id
        }
      });
    },
    goToEditPackage: function (pkg) {
      this.$router.push({
        name: this.routeName("edit_package"),
        params: {
          organization_id: this.organization_id,
          harvested_batch_id: this.harvested_batch_id,
          package_id: pkg.id
        }
      });
    },
    destroyPackage: async function (pkg) {
      pkg.proc_button_destroy = true;
      try {
        let response = await ManagePackageRequester.destroy(
          this.organization_id,
          this.harvested_batch_id,
          pkg.id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.packages.splice(this.packages.indexOf(pkg), 1);
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      pkg.proc_button_destroy = false;
    },
    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: this.harvest_process_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
